/* ==========================================================================
   tc-promo.js — kampanya rozetlerinin JS tarafı render'ı
   Dosya: assets/tc-promo.js

   TCPromo.render(keys, konum) -> HTML string

   ┌────────────────────────────────────────────────────────────────────────┐
   │ BU DOSYA EŞLEŞTİRME KURALI İŞLETMEZ.                                   │
   │ Kampanya–ürün eşleştirmesi yalnız snippets/tc-promo-match.liquid       │
   │ içinde yapılır. Burada yapılan tek şey, Liquid'in ürettiği anahtar     │
   │ listesini #tc-promos-data sözlüğünden okuyup                          │
   │ snippets/tc-promo-badges.liquid ile BYTE DÜZEYİNDE AYNI HTML üretmek.  │
   │                                                                        │
   │ HTML sözleşmesi tc-promo-badges.liquid başındaki yorumda tanımlı.      │
   │ İki dosyadan biri değişirse diğeri de değişmek ZORUNDA.               │
   └────────────────────────────────────────────────────────────────────────┘

   İstisna — instant search (konum 'arama'):
   Instant search kartları #tc-products-data'dan değil Shopify predictive search
   API'sinden geliyor, dolayısıyla product.promos taşımıyorlar. Bu tek durumda
   TCPromo.keysFor() hedef ÜYELİĞİNE bakar (kural işletmez): tarih/aktiflik/
   gösterim filtreleri Liquid'de zaten uygulanmış olarak #tc-promos-data'ya
   giriyor; burada sadece "bu ürün bu hedefin içinde mi" sorusu cevaplanır.
   Koleksiyon hedefleri için ürün id kümesi /collections/<handle>/products.json
   üzerinden bir kez çekilip sessionStorage'da tutulur.
   Gerekçe: docs/kampanya-sistemi.md
   ========================================================================== */
window.TCPromo = (function () {
  'use strict';

  var DATA = null;
  var SCOPE_CACHE = {};          // koleksiyon handle -> Set(product id)
  var SCOPE_PENDING = {};        // koleksiyon handle -> Promise
  var SS_PREFIX = 'tcPromoScope:';

  /* tc-collection.js içindeki esc() ile birebir aynı; Liquid | escape karşılığı */
  function esc(s) {
    return String(s === null || s === undefined ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* tc-collection.js içindeki money() ile birebir aynı (kuruş -> "1.234,56 TL") */
  function money(kurus) {
    return (kurus / 100).toLocaleString('tr-TR', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + ' TL';
  }

  function data() {
    if (DATA !== null) return DATA;
    var el = document.getElementById('tc-promos-data');
    if (!el) { DATA = { p: {}, o: [], sc: {} }; return DATA; }
    try {
      var parsed = JSON.parse(el.textContent);
      DATA = {
        p: parsed.p || {},
        o: parsed.o || [],
        sc: parsed.sc || {}
      };
    } catch (e) {
      DATA = { p: {}, o: [], sc: {} };
    }
    return DATA;
  }

  /* ---------------- SABİT İKON ----------------
     tc-promo-badges.liquid içindeki tc_pb_ico ile karakter karakter aynı olmalı. */
  var ICO = '<svg class="tc-promo__ico" width="12" height="12" viewBox="0 0 24 24" fill="none"'
    + ' stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"'
    + ' aria-hidden="true"><path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/>'
    + '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>'
    + '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';

  /* ---------------- RENDER ----------------
     keys  : "sepet30,sepet40" veya ["sepet30","sepet40"]
     konum : 'kart' | 'arama'
     price : (opsiyonel) kuruş cinsinden ürün fiyatı — yalnız 'kart' + ipucu modülü için
  */
  function render(keys, konum, price) {
    var list;
    if (!keys) return '';
    if (Array.isArray(keys)) list = keys;
    else list = String(keys).split(',');

    var D = data();
    var pri = '', sec = '', secN = 0, more = 0;
    var hint = '', hintN = 0, hintRate = 0;

    for (var i = 0; i < list.length; i++) {
      var k = String(list[i]).trim();
      if (!k) continue;
      var d = D.p[k];
      if (!d) continue;

      var txt = esc(String(d.t == null ? '' : d.t).trim());
      if (!txt) continue;

      if (d.h === 1 && d.r > 0) { hintN++; hintRate = d.r; }

      if (d.s === 'pri') {
        /* Birincil: yalnız ilki. link alanı kart içinde kullanılmaz (iç içe <a>). */
        if (pri === '') {
          pri = '<span class="tc-promo tc-promo--pri tcp--' + (d.c || 'notr') + '">'
              + ICO + '<span class="tc-promo__t">' + txt + '</span></span>';
        }
      } else {
        if (secN < 2) {
          sec += '<span class="tc-promo tc-promo--sec">' + txt + '</span>';
          secN++;
        } else {
          more++;
        }
      }
    }

    /* Stacking koruması: birden fazla kampanya ipucu istiyorsa hesap yanlış olur,
       modül otomatik devre dışı (tc-promo-badges.liquid ile aynı kural). */
    if (hintN === 1 && konum === 'kart' && typeof price === 'number' && price > 0) {
      hint = '<span class="tc-promo-hint">Sepette ~' + money(Math.round(price * (1 - hintRate))) + '</span>';
    }

    if (more > 0) {
      sec += '<span class="tc-promo tc-promo--sec tc-promo--more">+' + more + '</span>';
    }

    /* Eşleşme yoksa hiçbir DOM elemanı basma — kart yüksekliği bozulmasın. */
    if (pri === '' && sec === '') return '';
    return '<div class="tc-promos">' + pri + hint + sec + '</div>';
  }

  /* ---------------- INSTANT SEARCH HEDEF ÇÖZÜMLEMESİ ----------------
     Yalnız konum 'arama' için. Kural işletmez; üyelik bakar. */

  function scopeSet(handle) {
    if (SCOPE_CACHE[handle]) return Promise.resolve(SCOPE_CACHE[handle]);
    if (SCOPE_PENDING[handle]) return SCOPE_PENDING[handle];

    /* sessionStorage: sekme ömrü boyunca tek çekim */
    try {
      var raw = sessionStorage.getItem(SS_PREFIX + handle);
      if (raw) {
        var ids = JSON.parse(raw);
        SCOPE_CACHE[handle] = new Set(ids);
        return Promise.resolve(SCOPE_CACHE[handle]);
      }
    } catch (e) { /* sessionStorage kapalı olabilir — sorun değil, fetch'e düş */ }

    var acc = [];
    function page(n) {
      return fetch('/collections/' + encodeURIComponent(handle)
                 + '/products.json?limit=250&fields=id&page=' + n)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) {
          var arr = (j && j.products) || [];
          for (var i = 0; i < arr.length; i++) acc.push(arr[i].id);
          /* 250 dolduysa devam et; Shopify products.json sayfa başına en fazla 250 verir */
          if (arr.length === 250 && n < 12) return page(n + 1);
          return acc;
        });
    }

    SCOPE_PENDING[handle] = page(1).then(function (ids) {
      SCOPE_CACHE[handle] = new Set(ids);
      try { sessionStorage.setItem(SS_PREFIX + handle, JSON.stringify(ids)); } catch (e) {}
      delete SCOPE_PENDING[handle];
      return SCOPE_CACHE[handle];
    })['catch'](function () {
      /* Çekim başarısızsa rozet basmayız — yanlış rozet basmaktan iyidir. */
      SCOPE_CACHE[handle] = new Set();
      delete SCOPE_PENDING[handle];
      return SCOPE_CACHE[handle];
    });

    return SCOPE_PENDING[handle];
  }

  /* Bu arama oturumunda hangi koleksiyon hedeflerine ihtiyaç var? */
  function neededScopes() {
    var D = data(), out = [];
    for (var k in D.sc) {
      if (!Object.prototype.hasOwnProperty.call(D.sc, k)) continue;
      if (D.sc[k].t !== 'koleksiyon') continue;
      var vals = D.sc[k].v || [];
      for (var i = 0; i < vals.length; i++) {
        if (out.indexOf(vals[i]) === -1) out.push(vals[i]);
      }
    }
    return out;
  }

  /* Instant search açılırken çağır — kapsam kümelerini önceden hazırlar. */
  function warm() {
    var need = neededScopes();
    return Promise.all(need.map(scopeSet));
  }

  /* product: predictive search sonucu — { id, tags, vendor } yeter.
     Dönüş: global siralama'ya göre anahtar dizisi. */
  function keysFor(product) {
    var D = data();
    if (!product) return [];

    var tags = (product.tags || []).map(function (t) {
      return String(t).trim().toLowerCase();
    });
    var vendor = String(product.vendor || '').trim().toLowerCase();
    var pid = product.id;

    var out = [];
    for (var i = 0; i < D.o.length; i++) {
      var key = D.o[i];
      var sc = D.sc[key];
      if (!sc) continue;

      /* Hariç tutulan taglar */
      var excluded = false;
      var xs = sc.x || [];
      for (var j = 0; j < xs.length; j++) {
        if (tags.indexOf(xs[j]) !== -1) { excluded = true; break; }
      }
      if (excluded) continue;

      var hit = false;
      var vals = sc.v || [];
      if (sc.t === 'tumu') {
        hit = true;
      } else if (sc.t === 'tag') {
        for (var t = 0; t < vals.length; t++) {
          if (tags.indexOf(vals[t]) !== -1) { hit = true; break; }
        }
      } else if (sc.t === 'marka') {
        for (var m = 0; m < vals.length; m++) {
          if (vals[m] === vendor) { hit = true; break; }
        }
      } else if (sc.t === 'koleksiyon') {
        for (var c = 0; c < vals.length; c++) {
          var set = SCOPE_CACHE[vals[c]];
          /* Küme hazır değilse rozet basma — yanlış rozetten iyidir. warm() çağır. */
          if (set && set.has(pid)) { hit = true; break; }
        }
      }

      if (hit) out.push(key);
    }
    return out;
  }

  /* Instant search kartı için kısa yol: ürün -> HTML */
  function renderForSearch(product) {
    return render(keysFor(product), 'arama');
  }

  return {
    render: render,
    keysFor: keysFor,
    renderForSearch: renderForSearch,
    warm: warm,
    _data: data
  };
})();
